import React from "react";
import { useTranslation } from "react-i18next";
import { AppLayout } from "../../Layouts";
import PageLayout from "../../Layouts/PageLayout";
import { ProductsContent } from "../../Components";
import { useSelector } from "react-redux";
import { RootReducer } from "../../Store/reducers";

export function ProductsPage() {
  const { t } = useTranslation();
  const products = useSelector((state: RootReducer) => state.products);

  return (
    <AppLayout>
      <PageLayout
        title={t("products")}
        subtitle={
          products.length
            ? `${products.length} ${t("entries_found")}`
            : undefined
        }
      >
        <div className="h-fit max-w-1/2  bg-white rounded-xl shadow-accent-foreground shadow-2xl p-4 ">
          <ProductsContent />
        </div>
      </PageLayout>
    </AppLayout>
  );
}
